import { routes } from '@/configs/routes';
import { UserRole } from '@/lib/types';

export const getRestrictedRoutes = (role: UserRole) => {
  return routes.filter((route) => !route.permission.includes(role));
};

export function deepCopy<T>(obj: T) {
  return JSON.parse(JSON.stringify(obj)) as T;
}

// converts a Date object to a UTC ISO string at noon (12:00:00.000Z)
export function toUTCNoonISOString(date: Date | null) {
  if (!date) return null;

  const year = date.getFullYear();
  const month = date.getMonth();
  const day = date.getDate();

  const utcDate = new Date(Date.UTC(year, month, day, 12, 0, 0));
  return utcDate.toISOString();
}
